module.exports = __webpack_public_path__ + "assets/img/D2.89d04e80.jpg";